import { render, staticRenderFns } from "./uploadPhotos.vue?vue&type=template&id=ad84edde"
import script from "./uploadPhotos.vue?vue&type=script&lang=js"
export * from "./uploadPhotos.vue?vue&type=script&lang=js"
import style0 from "./uploadPhotos.vue?vue&type=style&index=0&id=ad84edde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports